import Utility from '@sparta.sales.utilities/module-utils-utility/dist/es6.js';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import $ from '@sparta.global.vendors/jquery';
import _ from '@sparta.global.vendors/lodash';
import { link } from '@sparta.global.helpers/sparta-helper/dist/es6.js';

const Handlebars = require('@sparta.global.vendors/handlebars');
const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <section class=\"row overview-accordion-nl-module\">\n    <section class=\"heading\">\n      <div class=\"row\">\n        <div class=\"small-12 column\">\n          <h3 data-font=\"cnx-regular\" class=\"large text-center\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"heading") : stack1), depth0)) != null ? stack1 : "")
    + "</h3>\n          <div class=\"content\">\n            "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"text") : stack1), depth0)) != null ? stack1 : "")
    + "\n          </div>\n        </div>\n      </div>\n      </section>\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"accordion") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":13,"column":6},"end":{"line":24,"column":13}}})) != null ? stack1 : "")
    + "  </section>\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <section class=\"accordion\">\n          <div class=\"moreNL-container\">\n            <span class=\"row moreNL-toggle\">\n              <div class=\"small-12 text-center column\"> "
    + container.escapeExpression((lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"LINKS") : depth0)) != null ? lookupProperty(stack1,"moreNLToggle") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":17,"column":56},"end":{"line":17,"column":84}}}))
    + "</div>\n            </span>\n            <div class=\"row moreNL-content\" style=\"display: none;\">\n                <div class=\"small-12 medium-12 column\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"moreNLContent") : stack1), depth0)) != null ? stack1 : "")
    + "</div>\n            </div>\n          </div>\n        </section>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"local") : depth0),{"name":"with","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":26,"column":9}}})) != null ? stack1 : "");
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.home-loans.modules/overview-accordion-nl-module",
  "version": "1.0.1",
  "id": "overviewAccordionNlModule",
  "containerID": "homeLoansOverviewAccordionNlModule",
  "moduleName": "home-loans-overview-accordion-nl-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "overview-accordion-nl-module",
  "data": {
    "init": "overviewAccordionNlModuleJS",
    "options": {}
  },
  "moduleParams": [{}],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        link
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    link
  },
  "dependencies": {
    "@sparta.sales.utilities/module-utils-utility": "^1.0.0",
    "@sparta.global.helpers/sparta-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.vendors/jquery": "^3.2.1",
    "@sparta.global.vendors/lodash": "^4.17.21"
  },
  "stores": []
};

/**
 * @export
 * @class overviewAccordionNlModuleJS
 * @extends Module
 */
class overviewAccordionNlModuleJS extends Module {
  /**
   * Initialize the module
   * @method constructor
   * @param {object} options options object
   * @param {object} context context object
   * @returns {void}
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    this.$target = $('.overview-accordion-nl-module');
  }

  /**
   * Initialize the module
   * @method init
   * @desc Initialize module
   * @memberof overviewAccordionNlModuleJS
   * @returns {void}
   */
  init() {
    const dropdownToggle = Utility.dropdownToggle(this.$target.find('.moreNL-content'), this.$target.find('.moreNL-toggle-image'));
    const decoratedDropdownToggle = () => {
      const open = '<span class="ada-hidden">expanded</span>';
      const close = '<span class="ada-hidden">collapsed</span>';
      dropdownToggle();
      const $link = this.$target.find('a.disclosures-toggle');
      const expanded = $link.attr('aria-expanded') || 'false';
      if (expanded === 'true') {
        $link.attr('aria-expanded', 'false');
        $link.find('.ada-hidden').remove();
        $link.append(close);
      } else {
        $link.attr('aria-expanded', 'true');
        $link.find('.ada-hidden').remove();
        $link.append(open);
      }
    };
    const $disclosuresToggle = this.$target.find('.moreNL-toggle');
    $disclosuresToggle.off();
    $disclosuresToggle.on('click', _.debounce(decoratedDropdownToggle, 200));
    const nlLocationURL = window.location.href;
    if (nlLocationURL.indexOf('/neighborhood-lending') !== -1) {
      this.$target.addClass('nl-overviewTab-margin');
    }
  }
}
registerModuleClass({
  moduleClass: overviewAccordionNlModuleJS,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { overviewAccordionNlModuleJS as default, moduleConfig };
